import  {useEffect, useState, useRef} from 'react'
import {KTCard, KTCardBody} from '../../../_metronic/helpers'
import {Spinner, Stack} from 'react-bootstrap'
import {UsersListPagination} from '../../modules/apps/user-management/users-list/components/pagination/UsersListPagination'
import plusIcon from '../../../_metronic/images/smlplus.svg'
import {useLazyQuery, useMutation} from '@apollo/client'
import {GETTPVADMINCLIENTSLIST, REMOVECLIENT, UPDATE_CLIENT_STATUS} from '../../../utils/GraphQLAPI'
import moment from 'moment'
import {CreateAppModal} from '../../../_metronic/partials'
import {CreateEditAppModal} from '../../../_metronic/partials/modals/create-app-stepper/CreateEditAppModal'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import searchicon from '../../../_metronic/images/hd_search.svg'
import '../../shared-css/Global.css'
import Dropdown from 'react-bootstrap/Dropdown'
import DownloadCsv from '../Download/DownloadCsv'
import SwalThinkingImage from '../../../_metronic/images/swal_thinking_face.svg'

const MySwal = withReactContent(Swal)

export default function ClientList() {
  const [page, updatePage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState<number>(10)
  const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false)
  const [addClient, setAddClient] = useState<any>()
  const [initialData, setInitialData] = useState<any>()
  const [total, setTotal] = useState<number>()
  const [previewUrl, setPreviewUrl] = useState<any>('')
  const [activate, setActivate] = useState<any>({id: '', isActive: ''})
  const [csv, setCsv] = useState<boolean>(false)
  const [downloadData, setDownloadData] = useState<any>([])
  const csvRef = useRef<any>(null)
  const [clientList, setClientList] = useState<any>([])
  const [removeClient, setRemoveClient] = useState<any>()
  const [searchText, setSearchText] = useState('')

  const [getTpvAdminClientList, {loading, refetch}] = useLazyQuery(GETTPVADMINCLIENTSLIST, {
    fetchPolicy: 'network-only',
    variables: {
      searchClientListInput: {
        searchText,
        page: page + 1,
        perPage: rowsPerPage,
      },
    },
    onCompleted: (data) => {
      setClientList(data.getTpvAdminClientsListBySearch.clients)
      setTotal(data.getTpvAdminClientsListBySearch.totalCount)
    },
  })

  // CSV API Hit
  const [getTpvAdminClientCSVList, {loading: reload}] = useLazyQuery(GETTPVADMINCLIENTSLIST, {
    fetchPolicy: 'network-only',
    variables: {
      searchClientListInput: {
        searchText,
      },
    },
    onCompleted: (data) => {
      setDownloadData(
        data.getTpvAdminClientsListBySearch.clients.map((client: any) => ({
          ...client,
          isActive: client.isActive ? 'Active' : 'Inactive',
        }))
      )
    },
  })

  const openModal = (event: any, value: any, clientData: any, previewurl: any) => {
    setPreviewUrl(previewurl)
    setShowCreateAppModal(event)
    setAddClient(value)
    if (value === 'Add') {
      setInitialData('')
    } else {
      setInitialData(clientData)
    }
  }

  const [deleteClient] = useMutation(REMOVECLIENT, {
    variables: {
      id: removeClient,
    },

    onCompleted: (data) => {
      refetch()
    },
  })
  const confirmTitle = 'Are you sure?'
  const cancelText = 'No, cancel !'
  const cancelBtnClr = 'rgb(39 37 37 / 52%)'
  const removeClients = async (id: any) => {
    setRemoveClient(id)
    MySwal.fire({
      title: confirmTitle,
      text: "You won't be able to revert this",
      iconHtml: `<img src=${SwalThinkingImage}>`,
      customClass: {
        icon: 'no-border',
      },
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it',
      confirmButtonColor: '#3E97FF',
      cancelButtonText: cancelText,
      cancelButtonColor: cancelBtnClr,
      reverseButtons: true,
    }).then(function (result) {
      if (result.value) {
        deleteClient()
        MySwal.fire({
          title: 'Deleted!',
          text: 'Your data has been deleted.',
          icon: 'success',
          confirmButtonColor: '#3E97FF',
        })
      }
    })
  }

  const refreshClientList = () => {
    refetch()
  }

  useEffect(() => {
    getTpvAdminClientList()
  }, [getTpvAdminClientList])

  const handleCloseModal = () => {
    setShowCreateAppModal(false)
  }

  useEffect(() => {
    getTpvAdminClientList()
  }, [searchText])

  const handleSearch = (value: any) => {
    updatePage(0)
    setSearchText(value)
  }

  const [updateScript] = useMutation(UPDATE_CLIENT_STATUS, {
    variables: {
      id: activate.id,
      isActive: activate.isActive,
    },
    onCompleted: (data) => {
      refetch()
    },
  })
  const clientAction = (result: any) => {
    if (result.value) {
      updateScript()
      MySwal.fire({
        title: 'Success!',
        text: 'Client status updated successfully',
        icon: 'success',
        confirmButtonColor: '#3E97FF',
      })
    }
  }

  const clientActivate = (e: any, id: any, activeValue: any) => {
    e.preventDefault()
    setActivate((prevOptions: any) => {
      return {...prevOptions, id, isActive: activeValue}
    })

    if (activeValue) {
      MySwal.fire({
        title: confirmTitle,
        iconHtml: `<img src=${SwalThinkingImage}>`,
        customClass: {
          icon: 'no-border',
        },
        showCancelButton: true,
        confirmButtonText: 'Yes, Activate it',
        confirmButtonColor: '#3E97FF',
        cancelButtonText: cancelText,
        cancelButtonColor: cancelBtnClr,
        reverseButtons: true,
      }).then(clientAction)
    } else {
      MySwal.fire({
        title: confirmTitle,
        iconHtml: `<img src=${SwalThinkingImage}>`,
        customClass: {
          icon: 'no-border',
        },
        showCancelButton: true,
        confirmButtonText: 'Yes, Inactivate it',
        confirmButtonColor: '#3E97FF',
        cancelButtonText: cancelText,
        cancelButtonColor: cancelBtnClr,
        reverseButtons: true,
      }).then(clientAction)
    }
  }

  const csvHeaders = [
    {label: 'Client Name', key: 'name'},
    {label: '# System Admins', key: 'noOfBrands'},
    {label: 'Latest Updated', key: 'updatedAt'},
    {label: 'Status', key: 'isActive'},
  ]

  const csvDownloadFun = async () => {
    await getTpvAdminClientCSVList()
    if (csvRef.current) {
      csvRef.current.link.click()
    }
  }
  return (
    <>
      <div className='d-flex flex-stack container-fluid mb-5' id='kt_app_toolbar_container'>
        <div className='d-flex flex-column'>
          <span className='fs-3 fw-bold text-gray-900'>Client List</span>
          <span className='text-gray-500 fw-semibold lh-20px fs-7'>Home - Client List</span>
        </div>
      </div>
      <KTCard>
        <div className='card card-custom'>
          <div className='card-header card-body pb-0 border-0'>
            <div className='card-title'>
              <div className='d-flex align-items-center position-relative my-1'>
                <input
                  type='text'
                  data-kt-ecommerce-order-filter='search'
                  className='form-control form-control-solid w-250px pe-14 bg-gray-200 search-bg-gray-200'
                  placeholder='Search client'
                  style={{backgroundColor: 'eff2f5!important'}}
                  onChange={(e) => handleSearch(e.target.value)}
                  value={searchText}
                />

                <span className='svg-icon svg-icon-1 position-absolute me-4' style={{right: 0}}>
                  <img src={searchicon} alt='search' />
                </span>
              </div>
            </div>
            <div className='card-toolbar flex-row-fluid justify-content-end gap-5'>
              <div className='m-0'>
                {total !== 0 && (
                  <DownloadCsv
                    csvDownloadFun={csvDownloadFun}
                    reload={reload}
                    csvHeaders={csvHeaders}
                    csvRef={csvRef}
                    downloadData={downloadData}
                    downloadFileName='Client.csv'
                  />
                )}
              </div>
              <button className='btn btn-primary' onClick={() => openModal(true, 'Add', '', '')}>
                <img src={plusIcon} alt='' className='svg-icon svg-icon-1' />
                <span>Add Client</span>
              </button>
            </div>
            {addClient && addClient === 'Edit' ? (
              <CreateEditAppModal
                show={showCreateAppModal}
                add={addClient}
                data1={initialData}
                image={previewUrl}
                handleClose={handleCloseModal}
                getTpvAdminClientList={getTpvAdminClientList}
                refreshList={refreshClientList}
              />
            ) : (
              <CreateAppModal
                show={showCreateAppModal}
                add={addClient}
                data1={initialData}
                handleClose={handleCloseModal}
                refreshList={refreshClientList}
                getTpvAdminClientList={getTpvAdminClientList}
              />
            )}
          </div>

          <KTCardBody className='px-9 py-0 min-h-400px mb-10' scroll={loading ? false : true}>
            {total !== 0 ? (
              <>
                {loading ? (
                  <div className='text-center'>
                    <Spinner animation='border' className='text-gray-600 text-center' role='status'>
                      <span className='visually-hidden'>Loading...</span>
                    </Spinner>
                  </div>
                ) : (
                  <table className='table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4'>
                    <thead>
                      <tr className='fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200'>
                        <th className='header-title min-w-450px'>Client Name</th>
                        <th className='header-title min-w-150px'># System Admins</th>
                        <th className='header-title min-w-200px'>Latest Updated</th>
                        <th className='header-title min-w-150px'>Status</th>
                        <th className='header-title min-w-50px'></th>
                      </tr>
                    </thead>
                    <tbody>
                      {clientList.map((item: any) => {
                        //image
                        return (
                          <>
                            <tr className='border-bottom-2' key={item.id}>
                              <td className='content min-w-450px'>
                                <div className='d-flex align-items-center'>
                                  <div className='symbol symbol-circle symbol-50px overflow-hidden me-3'>
                                    <img
                                      src={
                                        item.logoUrl
                                          ? `${process.env.REACT_APP_IMAGE_BASE_URL + item.logoUrl}`
                                          : 'https://cdn-icons-png.flaticon.com/512/5486/5486264.png'
                                      }
                                      style={{objectFit: 'contain'}}
                                      alt='Client_image'
                                    />
                                  </div>
                                  <Stack>
                                    <a className='text-gray-800 mb-1'>{item.name}</a>
                                    <span className='text-gray-400 fs-7'>
                                      {item.city && item.city + ','} {item.country} {item.zipCode}
                                    </span>
                                  </Stack>
                                </div>
                              </td>
                              <td className='content min-w-150px'>{item?.noOfBrands}</td>
                              <td className='content min-w-200px'>
                                {moment.utc(item.updatedAt).local().format('ll, hh:mm A')}
                              </td>
                              <td className='content min-w-150px'>
                                {item.isActive ? (
                                  <div className='badge badge-light-success fw-bolder'>Active</div>
                                ) : (
                                  <div className='badge badge-light-danger fw-bolder'>Inactive</div>
                                )}
                                <div className='badge badge-light-success fw-bolder'>{}</div>
                              </td>
                              <td className='content min-w-50px text-end'>
                                <Dropdown className='show-override'>
                                  <Dropdown.Toggle
                                    id='dropdown-custom-1'
                                    className='text-gray-600 btn btn-sm btn-icon btn-active-light-primary btn-light-primary btn-arrow-overide'
                                    style={{background: 'none!important'}}
                                  >
                                    <i className='bi bi-three-dots-vertical fs-7 text-primary'></i>
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu className='py-2 menu-state-bg-primary'>
                                    <Dropdown.Item
                                      as='div'
                                      className='text-gray-600 fs-7 menu-item p-0'
                                    >
                                      <div
                                        className='menu-link'
                                        onClick={() =>
                                          openModal(true, 'Edit', item.id, item.previewUrl)
                                        }
                                      >
                                        Edit
                                      </div>
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      as='div'
                                      className='text-gray-600 fs-7 menu-item p-0'
                                    >
                                      <div
                                        className='menu-link'
                                        onClick={(e) => {
                                          item.isActive
                                            ? clientActivate(e, item.id, false)
                                            : clientActivate(e, item.id, true)
                                        }}
                                      >
                                        {item.isActive ? 'Inactivate' : 'Activate'}
                                      </div>
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      as='div'
                                      className='text-gray-600 fs-7 menu-item p-0'
                                    >
                                      <div
                                        className='menu-link text-danger text-hover-white'
                                        onClick={() => removeClients(item.id)}
                                      >
                                        Delete
                                      </div>
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </td>
                            </tr>
                          </>
                        )
                      })}
                    </tbody>
                  </table>
                )}
              </>
            ) : (
              <div className='fs-4 fw-semibold text-center text-muted min-h-400px d-flex-align-items-center justify-content-center'>
                No Results Found
              </div>
            )}
          </KTCardBody>
          <div className='card-footer border-0'>
            <UsersListPagination
              page={page}
              total={total}
              updatePage={updatePage}
              recordsPerPage={(e: any) => {
                setRowsPerPage(parseInt(e))
              }}
              rowsPerPage={rowsPerPage}
            />
          </div>
        </div>
      </KTCard>
    </>
  )
}
